import Toast from "../../common/components/ui/toast";
import { ToastProvider } from "../../common/components/ui/toast/toast.provider";
import Dashboard from "../../common/components/layout/Dashboard";
import { ProductDashboard } from "./components/product-dashboard";

function ProductDetailsPage() {

  return (
    <ToastProvider>
      <Dashboard>
        <ProductDashboard />
      </Dashboard>
      <Toast />
    </ToastProvider>
  )
}

export default ProductDetailsPage